import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = {
  class: "add_big"
};
const _hoisted_2 = ["name"];
const _hoisted_3 = {
  class: "add_info"
};
const _hoisted_4 = {
  class: "add_edit"
};
const _hoisted_5 = {
  class: "form_button"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_nav_bar = _resolveComponent("van-nav-bar");
  const _component_van_tag = _resolveComponent("van-tag");
  const _component_van_icon = _resolveComponent("van-icon");
  const _component_router_link = _resolveComponent("router-link");
  const _component_van_button = _resolveComponent("van-button");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_van_nav_bar, {
    title: "收货地址",
    "left-arrow": "",
    onClickLeft: $setup.goBack,
    fixed: "",
    placeholder: ""
  }, null, 8, ["onClickLeft"]), _createElementVNode("div", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.list, item => {
    return _openBlock(), _createElementBlock("div", {
      class: "add_list",
      key: item.id,
      name: item.id
    }, [_createElementVNode("div", _hoisted_3, [_createElementVNode("dl", null, [_createElementVNode("dt", null, [_createTextVNode(_toDisplayString(item.name) + " " + _toDisplayString(item.phone) + " ", 1), item.default ? (_openBlock(), _createBlock(_component_van_tag, {
      key: 0,
      type: "primary"
    }, {
      default: _withCtx(() => _cache[0] || (_cache[0] = [_createTextVNode("默认")])),
      _: 1
    })) : _createCommentVNode("", true)]), _createElementVNode("dd", null, _toDisplayString(item.address), 1)])]), _createElementVNode("div", _hoisted_4, [_createVNode(_component_router_link, {
      to: "/address/edit?id=" + item.id
    }, {
      default: _withCtx(() => [_createVNode(_component_van_icon, {
        name: "edit"
      })]),
      _: 2
    }, 1032, ["to"])])], 8, _hoisted_2);
  }), 128))]), _createElementVNode("div", _hoisted_5, [_createVNode(_component_van_button, {
    type: "primary",
    round: "",
    block: "",
    onClick: $setup.addInfo
  }, {
    default: _withCtx(() => _cache[1] || (_cache[1] = [_createTextVNode("新增地址")])),
    _: 1
  }, 8, ["onClick"])])], 64);
}